import { gallery } from "./retrieve.js";

/* ===========================================================================
   Catalogue lookup.
   =========================================================================== */

/** Every printing of one indexed group — the README's ambiguity case, listed in full. */
export function printingsOf(row) {
  const c = gallery.catalogue;
  const from = c.offsets[row],
    to = c.offsets[row + 1];
  const out = [];
  for (let i = from; i < to; i++) {
    const [code, name] = c.dict.set[c.printing.set[i]];
    out.push({
      name: c.dict.name[c.printing.name[i]],
      setCode: code,
      setName: name,
      collector: c.printing.collector[i],
      rarity: c.dict.rarity[c.printing.rarity[i]],
      artist: c.dict.artist[c.printing.artist[i]],
      released: c.dict.released[c.printing.released[i]],
      scryfall: c.printing.scryfall[i],
      face: c.printing.face[i],
      foil: !!c.printing.foil[i],
      // Frame and full-art pick the OCR region preset; illustration is what tells a
      // reprint of the same picture from a genuinely different card.
      frame: c.dict.frame?.[c.printing.frame?.[i]] ?? "",
      fullArt: !!c.printing.full_art?.[i],
      illustration: c.dict.illustration?.[c.printing.illustration?.[i]] ?? "",
      usd: c.printing.usd?.[i] ?? null,
      usdFoil: c.printing.usd_foil?.[i] ?? null,
      eur: c.printing.eur?.[i] ?? null,
      eurFoil: c.printing.eur_foil?.[i] ?? null,
    });
  }
  return out;
}

/** Integer cents to a display string, or null when no price is recorded. */
export const money = (cents, symbol) => (cents == null ? null : symbol + (cents / 100).toFixed(2));

/**
 * The non-foil price of one printing, both currencies where known.
 *
 * Absent is shown as absent rather than as zero: about a fifth of printings carry no
 * price at all, and "—" is the honest rendering of that.
 */
export function priceLabel(printing) {
  const parts = [money(printing.usd, "$"), money(printing.eur, "€")].filter(Boolean);
  return parts.length ? parts.join(" · ") : "—";
}

export function foilLabel(printing) {
  const parts = [money(printing.usdFoil, "$"), money(printing.eurFoil, "€")].filter(Boolean);
  return parts.length ? `foil ${parts.join(" · ")}` : "";
}
